module.exports = __webpack_public_path__ + "img/full_collat.d03281f3.png";